import keyBy from "lodash/keyBy";
import { ICompetition } from "../../types/competition/Competition";
import * as types from "../actions/actionTypes";
import { IProcessedShiftSessionTransport } from "../api/shiftsApi";
import { ICompetitionState, InitialState } from "./state";

const getMappedStateWithCompetitions = (
  state: ICompetitionState,
  competitions: ICompetition[],
) => ({
  ...state,
  map: { ...state.map, ...keyBy(competitions, "_id") },
});

const handles = {
  [types.SHIFTS_GET_SHIFT_FULFILLED]: (state: ICompetitionState, payload: IProcessedShiftSessionTransport) =>
    getMappedStateWithCompetitions(state, payload.competitions),
  [types.COMPETITIONS_GET_ALL_FULFILLED]: getMappedStateWithCompetitions,
};

export default function competitionReducer(
  state: ICompetitionState = InitialState.competitions,
  action,
): ICompetitionState {
  return action.type && action.type in handles
    ? handles[action.type](state, action.payload)
    : state;
}
